import React, { useId, useState } from 'react';
import Cookies from 'universal-cookie';
import { Eye, EyeOff } from 'lucide-react';
import sales from '../Sales';
import { useAdmin } from './adminContext';
import { Button, Field, FormError } from './ui';

const cookies = new Cookies();

const cookieOptions = { path: '/', maxAge: 48000 * 48000 };

const PasswordForm = ({ title, text, updatesSession }) => {
  const { notify } = useAdmin();
  const id = useId();
  const empty = { current: '', next: '', repeat: '' };
  const [form, setForm] = useState(empty);
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState('');
  const set = (key) => (event) => setForm((previous) => ({ ...previous, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    if (!form.current || !form.next) {
      setProblem('Vul het huidige en het nieuwe wachtwoord in.');
      return;
    }
    if (form.next !== form.repeat) {
      setProblem('De twee nieuwe wachtwoorden zijn niet hetzelfde.');
      return;
    }
    if (form.next === form.current) {
      setProblem('Het nieuwe wachtwoord is hetzelfde als het huidige.');
      return;
    }

    setBusy(true);
    setProblem('');
    try {
      const res = await sales.put('changePassword', {
        password: form.next,
        oldPassword: form.current,
      });
      if (updatesSession && res.data?.api_key) {
        cookies.set('token', res.data.api_key, cookieOptions);
      }
      setForm(empty);
      notify(`${title} gewijzigd`);
    } catch (error) {
      console.warn(error);
      setProblem(
        error.response?.status === 404
          ? 'Het huidige wachtwoord klopt niet.'
          : 'Wijzigen is mislukt. Probeer het opnieuw.',
      );
    } finally {
      setBusy(false);
    }
  };

  const type = visible ? 'text' : 'password';

  return (
    <form className="adm-entry" onSubmit={submit} autoComplete="off">
      <div className="adm-entry-head">
        <div>
          <h1 className="adm-entry-title">{title}</h1>
          <p className="adm-entry-sub">{text}</p>
        </div>
      </div>
      <div className="adm-password-grid">
        <Field label="Huidig wachtwoord" htmlFor={`${id}-current`}>
          <input id={`${id}-current`} className="adm-input" type={type} value={form.current} onChange={set('current')} autoComplete="current-password" />
        </Field>
        <Field label="Nieuw wachtwoord" htmlFor={`${id}-next`}>
          <input id={`${id}-next`} className="adm-input" type={type} value={form.next} onChange={set('next')} autoComplete="new-password" />
        </Field>
        <Field label="Nieuw wachtwoord nog een keer" htmlFor={`${id}-repeat`}>
          <input id={`${id}-repeat`} className="adm-input" type={type} value={form.repeat} onChange={set('repeat')} autoComplete="new-password" />
        </Field>
      </div>
      <FormError>{problem}</FormError>
      <div className="adm-entry-actions">
        <button type="button" className="adm-link" onClick={() => setVisible((value) => !value)}>
          {visible ? <EyeOff size={15} aria-hidden /> : <Eye size={15} aria-hidden />}
          {visible ? 'Verberg' : 'Toon'} wachtwoorden
        </button>
        <span className="adm-grow" />
        <Button type="submit" disabled={busy}>
          {busy ? 'Bezig...' : 'Wachtwoord wijzigen'}
        </Button>
      </div>
    </form>
  );
};

const Passwords = () => (
  <>
    <PasswordForm title="Beheerderswachtwoord" text="Hiermee log je in op dit beheer." updatesSession />
    <PasswordForm
      title="Dashboardwachtwoord"
      text="Hiermee logt de TV in. Schermen die al ingelogd zijn, moeten daarna mogelijk opnieuw inloggen."
    />
  </>
);

export default Passwords;
